import { State } from 'flow/types/State';
import { DashboardKey } from 'flow/types/EntityKeys';
import { getWallboardUrl } from 'flow/utils/wallboard-utils';

export const selectDashboard = (state: State, key: DashboardKey) =>
    state.wallboards.getIn(['wallboards', key]);

export const selectDashboards = (state: State) =>
    state.wallboards.get('wallboards');

export const selectKey = (state: State, key: DashboardKey) =>
    selectDashboard(state, key)?.get('key');

export const selectName = (state: State, key: DashboardKey) =>
    selectDashboard(state, key)?.get('name');

export const selectType = (state: State, key: DashboardKey) =>
    selectDashboard(state, key)?.get('type');

export const selectUrl = (state: State, key: DashboardKey) => {
    const urlPath = selectDashboard(state, key)?.get('urlPath');
    return urlPath ? getWallboardUrl(urlPath) : '';
};
